import * as React from 'react';
import { MapPageFormFilter } from './Filters';
import { Moment } from 'moment';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

interface DateRangeFilterProps extends MapPageFormFilter {
    
}

export default function DateRangeFilter(props: DateRangeFilterProps) {
  const { value: formValue, onChange: updateForm, isLoading } = props;
  const [value, setValue] = React.useState<Moment[]|undefined>(formValue);

  return <RangePicker
    disabled={isLoading}
    placement={'bottomLeft'}
    value={formValue || value}
    allowEmpty={[true, true]}
    onChange={(dates: [Moment, Moment]) => {
      setValue(dates);
      updateForm && updateForm(dates);
    }}
  />
}